import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { GlobalSearchService } from '../services/globalsearchservice.service';
import { RuntimeConfigLoaderService } from 'runtime-config-loader';
import { DeviceService } from './device.service';

@Injectable({
	providedIn: 'root'
})
export class ClaudeService {

	private apiUrl: string;
	private apiKey: string;
	private user: any = null;
	private config: any = null;

	constructor(
	private globalSearchService: GlobalSearchService,
	private http: HttpClient,
	private _configSvc: RuntimeConfigLoaderService,
	private deviceService: DeviceService
	) {
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
			this.apiUrl = r?.apiServer?.endpoint;  // Get API URL from config
			this.apiKey = r?.apiCredentials?.clientId; // API Key from config
		});
		
		this.globalSearchService.user.subscribe(u => {
			this.user = u;
		});
	}

	/**
   * Sends a report to the backend PHP API for Claude processing.
   * @param report The report text to be analyzed.
   */
	public analyzeReport(report: string, type: any = ''): Observable<any> {
		// Use backend API endpoint to avoid CORS issues
		// The backend will proxy the request to Claude API
		const endpoint = this.setEndPoint();
		const payload = { report, type };
		
		// Build headers with proper authentication
		const headers = this.buildHeaders();
		
		console.log('🔗 ClaudeService.analyzeReport:', {
			endpoint,
			payloadSize: typeof report === 'string' ? report.length : JSON.stringify(report).length,
			type,
			hasAuth: !!headers.get('Authorization')
		});
	
		return this.http.post(endpoint, payload, { headers }).pipe(
	  catchError(this.handleError('analyzeReport', report))
		);
	}

	private buildHeaders(): HttpHeaders {
		const uuid = this.deviceService.getDeviceUUID();
		let headers = new HttpHeaders({
			'Content-Type': 'application/json',
			'X-Device-UUID': uuid
		});

		// Add Authorization header if we have config and user
		if (this.config?.apiCredentials?.clientId && this.user?.user?.userid) {
			const token = `${this.config.apiCredentials.clientId}_${this.user.user.userid}`;
			headers = headers.set('Authorization', `Bearer ${token}`);
		}

		return headers;
	}

	private setEndPoint(): string {
		// Use backend API endpoint to avoid CORS issues
		// Route format: ?route=apir/claude/analyze
		if (this.apiUrl) {
			// If endpoint already has ?route=apir/, append claude/analyze
			if (this.apiUrl.includes('?route=apir/')) {
				return this.apiUrl + 'claude/analyze';
			} else if (this.apiUrl.includes('?route=')) {
				// If it has ?route= but not apir/, replace it
				return this.apiUrl.split('?route=')[0] + '?route=apir/claude/analyze';
			} else {
				// No route parameter, add it
				return this.apiUrl + '?route=apir/claude/analyze';
			}
		}
		// Fallback to CDN if no API URL configured (will have CORS issues in dev)
		return 'https://cdn.beautyserv.com/upload/analyze';
	}

	private getApiKey() {
		return '&key=' + this.apiKey;
	}

	private handleError<T>(operation = 'operation', result?: T) {
		return (error: any): Observable<T> => {
	  if (error.status === 401) {
				window.location.href = '/#/auth/logout';
	  }
	  return throwError(() => new Error(`${operation} failed: ${error.message}`));
		};
	}
}
